import { Component, Fragment, h, Prop } from '@stencil/core';
import { store } from '../../../redux/store';
import { Unsubscribe } from '@stencil/redux';
import { closeCart, openCart, requireInit } from '../../../redux/actions';
import { Cart, SplitOption, Translations } from '../../../redux/types';
import { RootState } from '../../../redux/reducers';
import { RentwareCart } from '../rentware-cart';
import { CartIcon, ComponentView, Price, TotalPriceCalculation } from '../../../types/types';
import { PickerDate } from '../../rtr-article-details/utils/types';

@Component({
  tag: 'rentware-cart-expandable',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCartExpandable {
  @Prop({ mutable: true }) expanded = false;
  @Prop({ mutable: true }) cart: Cart;
  @Prop({ mutable: true }) icon: CartIcon;
  @Prop({ mutable: true }) translations: Translations;
  @Prop({ mutable: true }) loadedComponents;
  @Prop({ mutable: true }) paymentSplitOption: SplitOption;
  @Prop() checkoutNextClick;
  @Prop() customCartIcon: CartIcon = null; // for preview
  @Prop() cartView: ComponentView = ComponentView.Default;
  @Prop() pickerDate: PickerDate;

  unsubscribe!: Unsubscribe;
  requireInit!: typeof requireInit;
  openCart!: typeof openCart;
  closeCart!: typeof closeCart;

  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        cart: state.cart,
        expanded: state.app.expandCart,
        icon: state.system.widgetConfig?.advanced.cart.cartIcon,
        translations: state.system.translations,
        loadedComponents: state.app.loadedComponents,
        paymentSplitOption: state.app.paymentSplitOption,
      };
    });

    store.mapDispatchToProps(this, {
      requireInit,
      openCart,
      closeCart,
    });
  }

  componentDidLoad() {
    this.requireInit();
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  handleToggleCart = () => {
    (this.expanded === true && this.closeCart()) || this.openCart();
  };

  get buttonIconTotal() {
    return this.cart?.totalQuantityWithShipping ?? 0;
  }

  get depositPrice(): Price {
    return this.cart?.depositPrice;
  }

  get buttonIconPrice(): Price {
    if (this.cart?.totalPriceCalculation === TotalPriceCalculation.Month) {
      return this.cart?.discountedPricePerMonthWithoutDeposit;
    }

    return this.cart?.discountedPriceWithoutDeposit;
  }

  get isWaitingForDependencies() {
    return this.expanded && !this.loadedComponents[RentwareCart.name];
  }

  render() {
    return (
      <Fragment>
        {this.cartView === ComponentView.Default && (
          <rentware-cart-control-button
            iconId={this.icon}
            total={this.buttonIconTotal}
            onClick={this.handleToggleCart}
            isLoading={this.isWaitingForDependencies}
            customCartIcon={this.customCartIcon}
          />
        )}

        {this.cartView === ComponentView.Checkout && (
          <rentware-cart-control-button-checkout
            total={this.buttonIconTotal}
            price={this.buttonIconPrice}
            onClick={this.handleToggleCart}
            splitOption={this.paymentSplitOption}
            depositPrice={this.depositPrice}
          />
        )}

        {this.cartView === ComponentView.Details && <rentware-cart-control-button-details pickerDate={this.pickerDate} onToggleCart={this.handleToggleCart} cart={this.cart} />}

        {this.expanded && (
          <rentware-wrapper onClickOutside={this.closeCart}>
            <rentware-cart onClose={this.closeCart} cartView={this.cartView} checkoutNextClick={this.checkoutNextClick} pickerDate={this.pickerDate} />
          </rentware-wrapper>
        )}
      </Fragment>
    );
  }
}
